// extracted by mini-css-extract-plugin
export default {"rating":"LR-z","numberOfStars":"MR-z","count":"NR-z","barGraphSpacing":"OR-z","barGraph":"PR-z"};